import React from 'react';
import './Payment.scss';
import ContentLoader from 'react-content-loader';
const moment = require('moment');
const InvoiceCard = ({
  bill,
  downloadInvoice,
  loading,
  openCloseModal
}) => {
  const TableRow = props => {
    return (
      <ContentLoader
        height={65}
        width={685}
        speed={3}
        primaryColor="#fff"
        secondaryColor="#eceef4"
        {...props}
      >
        <rect x="4" y="10" rx="4" ry="4" width="50" height="20" />
        <rect x="80" y="10" rx="4" ry="4" width="50" height="20" />
        <rect x="155" y="10" rx="4" ry="4" width='50' height="20" />
        <rect x="230" y="10" rx="4" ry="4" width='90' height="20" />
        <rect x="375" y="10" rx="4" ry="4" width='65' height="20" />
        <rect x="465" y="10" rx="4" ry="4" width="100" height="20" />
        <rect x="630" y="10" rx="4" ry="4" width="50" height="20" />
      </ContentLoader>
    );
  };
  return (
    <div className="invoce-block mt-30">
      <div className="subheader-two-part ">
        <div className="header-sub-title header-subtitle-right ">
          <h4 className="mb-2">Invoice History</h4>
        </div>
      </div>
      <div className="clearfix"></div>
      <div className="card ph-0 pv-20 table-responsive">
        <table className="table tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-webllist">
          <thead className="">
            <tr>
              <th>Invoice</th>
              <th>Plan Id</th>
              <th>Plan</th>
              <th>Billed Date</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody>
            {
              loading === false ?
                bill && bill.length > 0 ?
                  bill.map((b, key) => {
                    return (
                      <tr key={key}>
                        <td className="plan-invoive">{b.iobj ? <i onClick={() => downloadInvoice(b.iobj.id)}><span className="invoice-dwn" >#{b.iobj.id} </span> </i> : '-'}</td>
                        <td>{b.wn}</td>
                        <td>
                          <h5 className="tbl-plan-text">{b.pobj.cf_plan_category}</h5>
                          <span>${b.price}/ {b.pdru == 'year' && b.pdr == '5' ? 'lifetime ' : b.pdru}</span>
                        </td>
                        <td>{moment(new Date(b.cdt)).format('MMM DD YYYY')}</td>
                        <td>{b.pst == 1 && 'Pending'}{b.pst == 2 && <span><span>Fail</span> {b.retry && <span onClick={() => openCloseModal('retry')}>|| Retry</span>} </span>}{b.pst == 3 && 'Success'}</td>
                        <td className="green-text">${b.price}</td>
                        <td>{b.tobj ? <span>{b.tobj.error_text}</span> : '-'}</td>
                      </tr>
                    );
                  })
                  :
                  <tr>
                    <td colSpan="7" className="text-center" > <p className="text-center m-0">No History Found </p> </td>
                  </tr>
                :
                <tr>
                  <td colSpan='7'>
                    {
                      Array(5)
                        .fill('')
                        .map((e, i) => (
                          <TableRow key={i} style={{ opacity: Number(2 / i).toFixed(1) }} />
                        ))
                    }
                  </td>
                </tr>
            }
          </tbody>
        </table>
      </div>
    </div >
  );
};

export default InvoiceCard;


// WEBPACK FOOTER //
// ./src/components/Payment/InvoiceCard.js